/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/no-inferrable-types */

/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */

export class UserConstants {
	public static nameMinLen: number = 4;
	public static nameMaxLen: number = 10;
	public static passMinLen: number = 4;
	public static resetPassPinCodeLen: number = 8;
}
